import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { axios } from 'lib/axios';
import { listParams, qnaKey } from './queryKeys';

const getSent = (resource, id, paging) =>
  axios.get(`/api/${resource}/${id}/qna/sent`, { params: listParams(paging) });

export const useSent = (resource, id, paging, options = {}) =>
  useQuery({
    queryKey: qnaKey(resource, id, 'sent', paging.page, paging.pageSize, paging.order),
    queryFn: () => getSent(resource, id, paging),
    select: ({ data }) => ({ items: data.data, total: data.total }),
    placeholderData: keepPreviousData,
    ...options,
  });
